import { useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { toast, Toaster } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Globe, Send, Check } from "lucide-react";

const PORTAL_KEY = "turismo-latina-portal-key-2026";

export default function PortalDemo() {
  const [f, setF] = useState({
    slug: "trattoria-del-circeo", customer_name: "Turista Demo", customer_phone: "+39 333 9998887",
    customer_email: "turista@email.it", party_size: 2,
    date: new Date().toISOString().slice(0, 10), time: "20:00", notes: "Richiesta dal portale",
  });
  const [sent, setSent] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const send = async () => {
    try {
      await axios.post(`${API}/portal/lead`, { ...f, party_size: Number(f.party_size) },
        { headers: { "X-Portal-Key": PORTAL_KEY } });
      setSent(true);
      toast.success("Lead inviato alla dashboard dell'attività ✅");
    } catch (e) { toast.error(e?.response?.data?.detail || "Errore invio lead"); }
  };

  return (
    <div className="min-h-screen bg-slate-900 text-white">
      <Toaster position="top-center" richColors />
      <div className="max-w-lg mx-auto p-6">
        <div className="flex items-center gap-2 mb-6">
          <div className="grid h-10 w-10 place-items-center rounded-xl bg-primary"><Globe className="h-5 w-5" /></div>
          <div><p className="font-heading font-bold text-lg">turismo.latina.it</p><p className="text-xs text-slate-400">Demo portale — genera un lead di prova</p></div>
        </div>

        <div className="rounded-2xl bg-slate-800 border border-slate-700 p-6 space-y-4">
          <p className="text-sm text-slate-300">Questa pagina simula il portale turistico. Compila e invia: la richiesta arriverà nella dashboard dell'attività (sezione <b>Lead Portale</b>) con notifica WhatsApp automatica.</p>

          <div><Label className="text-slate-300">Slug attività</Label><Input value={f.slug} onChange={(e) => set("slug", e.target.value)} className="bg-slate-900 border-slate-700 text-white" data-testid="portal-slug-input" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label className="text-slate-300">Nome turista</Label><Input value={f.customer_name} onChange={(e) => set("customer_name", e.target.value)} className="bg-slate-900 border-slate-700 text-white" data-testid="portal-name-input" /></div>
            <div><Label className="text-slate-300">Telefono</Label><Input value={f.customer_phone} onChange={(e) => set("customer_phone", e.target.value)} className="bg-slate-900 border-slate-700 text-white" data-testid="portal-phone-input" /></div>
          </div>
          <div className="grid grid-cols-3 gap-3">
            <div><Label className="text-slate-300">Persone</Label><Input type="number" value={f.party_size} onChange={(e) => set("party_size", e.target.value)} className="bg-slate-900 border-slate-700 text-white" data-testid="portal-party-input" /></div>
            <div><Label className="text-slate-300">Data</Label><Input type="date" value={f.date} onChange={(e) => set("date", e.target.value)} className="bg-slate-900 border-slate-700 text-white" data-testid="portal-date-input" /></div>
            <div><Label className="text-slate-300">Ora</Label><Input type="time" value={f.time} onChange={(e) => set("time", e.target.value)} className="bg-slate-900 border-slate-700 text-white" data-testid="portal-time-input" /></div>
          </div>

          <Button onClick={send} className="w-full rounded-xl h-11" data-testid="portal-send-btn">
            {sent ? <><Check className="h-4 w-4 mr-1" /> Inviato — invia un altro</> : <><Send className="h-4 w-4 mr-1" /> Prenota su turismo.latina.it</>}
          </Button>
          {sent && <p className="text-center text-emerald-400 text-sm">Apri la dashboard → Lead Portale per vederlo.</p>}
        </div>
      </div>
    </div>
  );
}
